"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const StyledBox = (0, styled_components_1.default)(material_1.Box) `
  margin-left: ${props => props.ml};
  margin-right: ${props => props.mr};
  margin-top: ${props => props.mt};
  margin-bottom: ${props => props.mb};
  margin: ${props => props.m};
  padding-left: ${props => props.pl};
  padding-right: ${props => props.pr};
  padding-top: ${props => props.pt};
  padding-bottom: ${props => props.pb};
  padding: ${props => props.p};
  width: ${props => props.w || props.width || 'fit-content'};
`;
exports.default = StyledBox;
